// Constants
import { WebUrlSegments } from "@ms/uno-constants/lib/local/WebConstants";
// Factories
import { BaseStoreLoader } from "../../base/loaders/BaseStoreLoader";
/**
 * Loader class for store providers in Web app
 */
export class WebStoreLoader extends BaseStoreLoader {
    // TODO[UnoWeb] ADO#9153353 - We only need to do this while we don't have AFD mapping
    getRouteStorePathPrefix() {
        // This is the UNO Web endpoint on MTRS
        return WebUrlSegments.WebUI;
    }
}
